import { get } from '../../api/client';
import { toLocalDateString } from '../../utils/dateUtils';

/**
 * 活动公开端点的读取与显示口径。
 *
 * GET /public/campaigns 与 /public/campaigns/:key 只下发「已上线且此刻在窗口内」的活动，
 * 下线、未开始、已结束一律按「不存在」回话（后端 campaign-public.controller.ts 同一句中文提示），
 * 所以这里不需要再判一遍状态，也不必为「活动存在但已结束」做第二套界面。
 */

/** 列表行：后端刻意不给正文与已发名额 */
export interface CampaignSummary {
  key: string;
  title: string;
  subtitle: string | null;
  heroImage: string | null;
  /** 服务端现算的一句话（如「注册即送 7 天会员」），为空表示这个活动不发会员 */
  benefitText: string | null;
  startAt: string | null;
  endAt: string | null;
}

/** 详情：多正文与 noindex，少 maxGrants（名额进度不对外） */
export interface CampaignDetail extends CampaignSummary {
  bodyMd: string | null;
  noindex: boolean;
}

export function fetchCampaigns(): Promise<CampaignSummary[]> {
  return get<CampaignSummary[]>('/public/campaigns');
}

export function fetchCampaign(key: string): Promise<CampaignDetail> {
  return get<CampaignDetail>(`/public/campaigns/${encodeURIComponent(key)}`);
}

/**
 * 活动时间窗口的中文说法。
 *
 * 两端都可为空（空＝不设限），所以四种组合都要有话可说；日期走 toLocalDateString 取本地日历日，
 * 后端下发的是 UTC 时刻串，直接截字符串会在晚上八点之后差一天。
 */
export function campaignWindowText(c: { startAt: string | null; endAt: string | null }): string {
  const start = toLocalDateString(c.startAt);
  const end = toLocalDateString(c.endAt);
  if (start && end) return `${start} 至 ${end}`;
  if (start) return `${start} 开始`;
  if (end) return `${end} 结束`;
  return '长期有效';
}
